var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "basic",
    viewBox: "0 0 100 100",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a29a",
    d: "M40,76c-4,0-7,2.686-7,6h34c0-3.314-3-6-7-6h-6v-8h-8v8H40z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#78ccd3",
    d: "M79,21H21c-3.314,0-6,2.686-6,6v35c0,3.314,2.686,6,6,6h58c3.314,0,6-2.686,6-6V27 C85,23.686,82.314,21,79,21z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1cfc2",
    d: "M79,21H21c-3.314,0-6,2.686-6,6v2h70v-2C85,23.686,82.314,21,79,21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1cfc2",
    d: "M85,62v-2H15v2c0,3.314,2.686,6,6,6h24h10h24C82.314,68,85,65.314,85,62z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.5,
    cy: 63.5,
    r: 1.5,
    fill: "#f9e65c"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 63.5,
    r: 1.5,
    fill: "#70b570"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 1.5,
    fill: "#e85654"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M53,68v8c0,0.552,0.448,1,1,1h6c2.952,0,5.343,1.691,5.885,4h-31.77c0.542-2.309,2.933-4,5.885-4h6 c0.552,0,1-0.448,1-1v-8h-2v7h-5c-4.49,0-8.006,3.08-8,7.01c0.001,0.546,0.454,0.99,1,0.99h34c0.546,0,0.999-0.444,1-0.99 c0.006-3.93-3.51-7.01-8-7.01h-5v-7H53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M51.5,77H45c-0.276,0-0.5-0.224-0.5-0.5S44.724,76,45,76h6.5c0.276,0,0.5,0.224,0.5,0.5 S51.776,77,51.5,77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M72.5,30h-54c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h54c0.276,0,0.5,0.224,0.5,0.5 S72.776,30,72.5,30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M85,30h-9.5c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5H85c0.276,0,0.5,0.224,0.5,0.5 S85.276,30,85,30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M25.5,60H15c-0.276,0-0.5-0.224-0.5-0.5S14.724,59,15,59h10.5c0.276,0,0.5,0.224,0.5,0.5 S25.776,60,25.5,60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M85,60H38.5c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5H85c0.276,0,0.5,0.224,0.5,0.5 S85.276,60,85,60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M34.5,60h-6c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h6c0.276,0,0.5,0.224,0.5,0.5 S34.776,60,34.5,60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M69.5,65.5c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S70.603,65.5,69.5,65.5z M69.5,62.5 c-0.551,0-1,0.449-1,1s0.449,1,1,1s1-0.449,1-1S70.051,62.5,69.5,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M75.5,65.5c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S76.603,65.5,75.5,65.5z M75.5,62.5 c-0.551,0-1,0.449-1,1s0.449,1,1,1s1-0.449,1-1S76.051,62.5,75.5,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M63.5,65.5c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S64.603,65.5,63.5,65.5z M63.5,62.5 c-0.551,0-1,0.449-1,1s0.449,1,1,1s1-0.449,1-1S64.051,62.5,63.5,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M21,69c-3.86,0-7-3.14-7-7V27c0-3.86,3.14-7,7-7h58c3.86,0,7,3.14,7,7v35c0,3.86-3.14,7-7,7H21z M79,67c2.757,0,5-2.243,5-5V27c0-2.757-2.243-5-5-5H21c-2.757,0-5,2.243-5,5v35c0,2.757,2.243,5,5,5H79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/assets.60189f724cd58d8be0bde249e27ab947.svg";
export { ForwardRef as ReactComponent };